const ZERO_DECIMAL: ReadonlySet<string> = new Set(["PYG", "JPY", "KRW", "CLP", "VND"]);

export function formatAmount(amountMinor: string, currency: string, locale = "es-PY"): string {
  const minor = Number(amountMinor);
  if (!Number.isFinite(minor)) return `${amountMinor} ${currency}`;
  const decimals = ZERO_DECIMAL.has(currency) ? 0 : 2;
  const value = decimals === 0 ? minor : minor / 100;
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(value);
  } catch {
    return `${value.toFixed(decimals)} ${currency}`;
  }
}

export function formatExpiresAt(iso: string, locale = "es-PY"): string {
  try {
    return new Intl.DateTimeFormat(locale, {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}
